<template>
    <div class="d-flex p-3 text-white bg-blur-darker justify-content-between align-items-center">
        <h5 class="mb-0">{{ header }}</h5>
        <button class="btn d-lg-none text-light mr-3" type="button" @click.prevent="$parent.$emit('showNav')">
            <i class="fas fa-bars"></i>
        </button>
    </div>
</template>

<script>
    export default {
        name: "TabHeader",
        props: {
            header: String
        }
    }
</script>